import { lazy, Suspense } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthSessionProvider } from './hooks/useAuthSession';

const LandingPage = lazy(() => import('./pages/LandingPage').then((module) => ({ default: module.LandingPage })));
const IntroPage = lazy(() => import('./pages/IntroPage').then((module) => ({ default: module.IntroPage })));
const AgreementPage = lazy(() => import('./pages/AgreementPage').then((module) => ({ default: module.AgreementPage })));
const ApplicationPage = lazy(() => import('./pages/ApplicationPage').then((module) => ({ default: module.ApplicationPage })));
const StatusPage = lazy(() => import('./pages/StatusPage').then((module) => ({ default: module.StatusPage })));
const CreatorTokenPage = lazy(() => import('./pages/CreatorTokenPage').then((module) => ({ default: module.CreatorTokenPage })));
const MCNDashboardPage = lazy(() => import('./pages/MCNDashboardPage').then((module) => ({ default: module.MCNDashboardPage })));
const SignInPage = lazy(() => import('./pages/SignInPage').then((module) => ({ default: module.SignInPage })));
const SignUpPage = lazy(() => import('./pages/SignUpPage').then((module) => ({ default: module.SignUpPage })));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 15_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

function RoutedApp() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div className="loading-block">Loading onboarding…</div>}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/intro" element={<IntroPage />} />
          <Route path="/agreement" element={<AgreementPage />} />
          <Route path="/form" element={<ApplicationPage />} />
          <Route path="/pending" element={<StatusPage />} />
          <Route path="/creator-token" element={<CreatorTokenPage />} />
          <Route path="/mcn-dashboard" element={<MCNDashboardPage />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export function App() {
  return (
    <AuthSessionProvider>
      <QueryClientProvider client={queryClient}>
        <RoutedApp />
      </QueryClientProvider>
    </AuthSessionProvider>
  );
}
